import { render, staticRenderFns } from "./ErrorMessageSheet.vue?vue&type=template&id=2dc4e7d0"
import script from "./ErrorMessageSheet.vue?vue&type=script&lang=js"
export * from "./ErrorMessageSheet.vue?vue&type=script&lang=js"
import style0 from "./ErrorMessageSheet.vue?vue&type=style&index=0&id=2dc4e7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports